type Executor = (resolve: () => void, reject: () => void) => void

class UserGesturePromise {
  promise: Promise<void> | undefined
  executor: Executor

  constructor(executor: Executor) {
    this.promise = new Promise(executor)
    this.executor = executor
  }

  then(callback: () => void) {
    if (!this.promise) {
      this.promise = new Promise(this.executor)
    }

    return this.promise.then(callback)
  }
}

export { UserGesturePromise }
